import gsap from 'gsap'

export function initGlobalTouchEffect() {
  window.addEventListener('click', (e) => {
    const { clientX: x, clientY: y } = e
    createTouchSparkEffect(x, y)
  })
}

function createTouchSparkEffect(x, y) {
  const ripple = document.createElement('div')
  ripple.className = 'global-touch-ripple'
  ripple.style.left = `${x}px`
  ripple.style.top = `${y}px`
  document.body.appendChild(ripple)

  gsap.fromTo(
    ripple,
    { scale: 0.25, opacity: 0.92 },
    {
      scale: 1.9,
      opacity: 0,
      duration: 0.52,
      ease: 'power2.out',
      onComplete: () => ripple.remove(),
    }
  )

  const count = 7
  for (let i = 0; i < count; i++) {
    const star = document.createElement('div')
    star.className = 'global-touch-star'
    star.style.left = `${x}px`
    star.style.top = `${y}px`
    star.style.width = `${6 + Math.random() * 6}px`
    star.style.height = star.style.width
    document.body.appendChild(star)

    const angle = (Math.PI * 2 * i) / count + (Math.random() - 0.5) * 0.45
    const distance = 20 + Math.random() * 24
    const dx = Math.cos(angle) * distance
    const dy = Math.sin(angle) * distance

    gsap.fromTo(
      star,
      { x: 0, y: 0, scale: 0.45, opacity: 0.95, rotate: Math.random() * 60 },
      {
        x: dx,
        y: dy,
        scale: 0.15,
        opacity: 0,
        rotate: 140 + Math.random() * 160,
        duration: 0.6 + Math.random() * 0.18,
        ease: 'power2.out',
        onComplete: () => star.remove(),
      }
    )
  }
}
